import toast, { Toaster } from 'react-hot-toast';
import Quantity from '../crud/quantity';



// Search Barcode

const handleBarcode = (event, salableData, setShowProducts, barCodeSearch, setBarCodeSearch, handleAddToCart) => {
  if (event.key === 'Enter') {
    if (parseInt(barCodeSearch.substring(0, 2), 10) === 99) {
      handleScale(salableData, barCodeSearch, handleAddToCart);
    } else {
      let filteredProducts = [];
      let filteredBarcode = [];

      // For product name search (partial match)
      filteredProducts = salableData.filter(product => {
        return product.name.toLowerCase().includes(barCodeSearch.toLowerCase());
      });

      // For barcode search (partial match instead of exact match)
      filteredBarcode = salableData.filter(product => {
        return product.barcode && product.barcode.toLowerCase().includes(barCodeSearch.toLowerCase());
      });

      if (filteredBarcode.length > 0) {
        // If we find barcode matches, add the first one to cart
        handleAddToCart(filteredBarcode[0], 1);
      } else if (filteredProducts.length > 0) {
        // If no barcode matches but product name matches, show products
        setShowProducts(filteredProducts);
      } else {
        // If no matches at all, show a message
        toast.error('No products found');
      }
    }

    setBarCodeSearch('');
  }
};

const handleBarcodeWithoutInclude = (event, salableData, setShowProducts, barCodeSearch, setBarCodeSearch, handleAddToCart) => {

  if (event.key === 'Enter') {

    // 1. Handle scale barcodes first (this logic is unchanged)
    if (parseInt(barCodeSearch.substring(0, 2), 10) === 99) {
      handleScale(salableData, barCodeSearch, handleAddToCart);
    }
    else {

      // 2. Find all products where name includes the search term
      const filteredProducts = salableData.filter(product => {
        return product.name.toLowerCase().includes(barCodeSearch.toLowerCase());
      });

      // 3. Find all products where barcode *exactly* matches
      const filteredBarcode = salableData.filter(product => {
        return product.barcode && product.barcode.toLowerCase() === barCodeSearch.toLowerCase();
      });

      // 4. Use a Map to combine the lists and automatically handle duplicates
      const combinedProductMap = new Map();

      // Add all name matches
      filteredProducts.forEach(product => {
        combinedProductMap.set(product.id, product);
      });

      // Add all exact barcode matches (this will overwrite if already present, which is fine)
      filteredBarcode.forEach(product => {
        combinedProductMap.set(product.id, product);
      });

      // 5. Convert the map's values back into an array
      const combinedResults = Array.from(combinedProductMap.values());

      // 6. Now, just show the results or a toast. We NEVER call handleAddToCart.
      if (combinedResults.length > 0) {
        setShowProducts(combinedResults);
      } else {
        toast.error('No products found');
      }
    }

    setBarCodeSearch('');
  }
};


//  Scale
const handleScale = (salableData, barCodeSearch, handleAddToCart) => {

  let BarCodeProducts = [];

  const barcode = barCodeSearch.substring(2, 7);
  const price = barCodeSearch.substring(7, 12);
  const weight = parseFloat(barCodeSearch.substring(12, 17)) / 1000;
  const digitCheckSum = barCodeSearch.substring(17, 18);


  BarCodeProducts = salableData.filter(product => {
    return product.barcode === barcode;
  });

  if (BarCodeProducts.length > 0) {
    let ScaleProduct = { ...BarCodeProducts[0] };
    ScaleProduct.price = BarCodeProducts[0].price;
    handleAddToCart(ScaleProduct, weight);
  }



};

export {
  handleBarcode,
  handleBarcodeWithoutInclude,
};